import React, { useState, memo } from "react";
import { Card, CardContent } from "@material-ui/core";
import { useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { API } from "shared/services";
import { toast } from "react-toastify";

function BarChart({ title, url, setDataConfig }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    url && loadData();
  }, [url]);

  function loadData() {
    setLoading(true);

    API.get(url)
      .then((result) => setData(result.data))
      .catch(() => toast.warn("Não foi possível carregar o gráfico"))
      .finally(() => setLoading(false));
  }

  const dataConfig = (canvas) => {
    return setDataConfig(data, canvas);
  };

  return (
    <Card
      style={{
        maxWidth: "100%",
        padding: 32,
        borderWidth: 2,
        marginTop: 16,
      }}
    >
      {url && !loading ? (
        <>
          <h2>{title}</h2>

          <CardContent>
            <Bar
              data={dataConfig}
              height={50}
              options={{
                animation: {
                  duration: 0,
                },
                scales: {
                  myScale: {
                    type: "linear",
                    position: "left",
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                },
              }}
            />
          </CardContent>
        </>
      ) : (
        <p>carregando...</p>
      )}
    </Card>
  );
}

export default memo(BarChart);
